import { Icon } from "@lynx/ui-components";
import { Tooltip } from "react-tooltip";

import WireWidgetCard, { StatusPill } from "./WireWidgetCard";
import { formatWireAmount, getPayoutProgress, getWireAmount } from "../wireUtils";

const AVAILABLE_INFO =
  "Available for payout may be lower than your balance. It can exclude funds reserved for upcoming fees and other obligations.";

/**
 * Request pay-out. One active manual request at a time: while a request is
 * open the widget shows it ("View request") instead of the request form.
 */
const RequestPayoutWidget = ({
  availableForPayout,
  hasBankAccount,
  activeManualPayout,
  onRequest,
  onViewRequest,
}) => {
  if (activeManualPayout) {
    const progress = getPayoutProgress(activeManualPayout);
    const note =
      progress === "in_progress"
        ? "Support is processing this payout."
        : "You can request another payout after this one is resolved.";
    return (
      <WireWidgetCard
        title="Request payout"
        actions={[{ id: "request-payout-view", label: "View request", onClick: onViewRequest }]}
      >
        <div className="widget-line">
          <span className="widget-label">Requested amount</span>
        </div>
        <div className="widget-amount">
          {formatWireAmount(getWireAmount(activeManualPayout))}
          <StatusPill progress={progress} />
        </div>
        <div className="widget-muted">{note}</div>
      </WireWidgetCard>
    );
  }

  const available = typeof availableForPayout === "number" ? availableForPayout : 0;
  const noFunds = available <= 0;
  let note;
  if (!hasBankAccount) {
    note = "Add bank details before submitting your payout.";
  } else if (noFunds) {
    note = "No funds are currently available for payout.";
  } else {
    note = "Request all or part of the available amount.";
  }

  return (
    <WireWidgetCard
      title="Request payout"
      actions={[
        {
          id: "request-payout-btn",
          label: "Request payout",
          onClick: onRequest,
          disabled: noFunds,
        },
      ]}
    >
      <div className="widget-line">
        <span className="widget-label">Available for payout</span>
        <Icon id="payout-available-info" name="info" className="widget-info-icon" />
        <Tooltip
          className="wire-info-tooltip"
          delayShow={200}
          delayHide={300}
          anchorSelect="#payout-available-info"
          content={AVAILABLE_INFO}
        />
      </div>
      <div className="widget-amount">{formatWireAmount(available)}</div>
      <div className="widget-muted">{note}</div>
    </WireWidgetCard>
  );
};

export default RequestPayoutWidget;
